import { View } from "extensions/marionette";

import reportTemplate from "./report.jst";

export const Report = View.extend({
    controls: true,
    className() {
        return `report ${this.model.get("section_id")}`;
    },
    template: reportTemplate,
    triggers: {
        "click [data-action='action:open']": "action:open",
        "click [data-action='action:delete']": "action:delete"
    },
    templateContext() {
        return {
            controls: this.getOption("controls")
        };
    }
});
